import { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";

export default function EditPortfolio() {

  const { id } = useParams();  
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [oldImage, setOldImage] = useState(""); // existing image
  const [newImage, setNewImage] = useState(null); // new file
  const [loading, setLoading] = useState(true);

  // Fetch Existing Project Data
  useEffect(() => {
    axios
      .get(`https://apnaqwebx-mern.onrender.com/api/portfolio/${id}`)
      .then((res) => {
        setTitle(res.data.title);
        setUrl(res.data.url);
        setOldImage(res.data.image);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        alert("Failed to load project");
        navigate("/admin/portfolio");
      });
  }, [id, navigate]);

  // Update Handler
  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("url", url);

    // Only upload image if user selected a new file
    if (newImage) {
      formData.append("image", newImage);
    }

    try {
      await axios.put(
        `https://apnaqwebx-mern.onrender.com/api/portfolio/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert("Project updated successfully!");
      navigate("/admin/portfoliolist");

    } catch (error) {
      console.log(error);
      alert("Error updating project.");
    }
  };

  if (loading)
    return (
      <p className="text-center pt-40 text-gray-600 text-lg">
        Loading project...
      </p>
    );

  return (
    <div className="p-6 md:pt-32 pt-44 max-w-2xl mx-auto">

       <div className="flex justify-between items-center mb-6">
                {/* Heading */}
                <h2 className="text-3xl font-bold text-[#895712] text-center ">
                    Edit Portfolio Project
                </h2>

                <Link to="/admin/portfoliolist" ><i className="fa-solid fa-square-caret-left text-3xl text-[#895712]"></i></Link>
            </div>

      <form onSubmit={handleUpdate} className="space-y-6">

        {/* TITLE */}
        <div>
          <label className="text-gray-700 font-semibold">Project Title</label>
          <input
            type="text"
            className="w-full mt-1 p-3 border rounded-lg outline-none focus:border-[#855109]"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* WEBSITE URL */}
        <div>
          <label className="text-gray-700 font-semibold">Website URL</label>
          <input
            type="text"
            className="w-full mt-1 p-3 border rounded-lg outline-none focus:border-[#855109]"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>

        {/* CURRENT IMAGE PREVIEW */}
        <div>
          <label className="text-gray-700 font-semibold">Current Image</label>
          <img
            src={oldImage}
            alt="Current"
            className="w-full h-48 object-cover rounded-lg mt-2 border"
          />
        </div>

        {/* IMAGE UPLOAD */}
        <div>
          <label className="text-gray-700 font-semibold">Upload New Image</label>
          <input
            type="file"
            accept="image/*"
            className="w-full mt-1 p-3 border rounded-lg"
            onChange={(e) => setNewImage(e.target.files[0])}
          />
          <p className="text-sm text-gray-600 mt-1">
            (Leave empty to keep existing image)
          </p>
        </div>

        {/* BUTTON */}
        <button
          type="submit"
          className="w-full py-3 bg-[#855109] text-white font-bold rounded-lg hover:bg-[#6e4208] transition"
        >
          Update Project
        </button>

      </form>

    </div>
  );
}
